export default {
  list: [],
  listLoading: true,
  listRender: false,
  length: 0
}
